import BitmapData = createjs.BitmapData;

/**
 *
 * represents a flatened image with custom registration points. component
 * of GoodgameBitmapClip
 *
 * @author dkoehler
 *
 */
export class FlattenedImage extends BitmapData {
    /** registration point for x-axis. */
    private _registrationPointX: number = 0;

    /** registration point for x-axis. */
    public get registrationPointX(): number {
        return this._registrationPointX;
    }

    /** registration point for y-axis. */
    private _registrationPointY: number = 0;

    /** registration point for y-axis. */
    public get registrationPointY(): number {
        return this._registrationPointY;
    }

    public setRegistrationPointX(value: number): void {
        this._registrationPointX = value;
    }

    public setRegistrationPointY(value: number): void {
        this._registrationPointY = value;
    }

    /**
     * constructor
     *
     * @param width width of this image
     * @param height height of this image
     * @param regPntX registration poin on x-axis
     * @param regPntY registration poin on y-axis
     * @param bgColor background color for debugging
     *
     */
    constructor(width: number, height: number, regPntX: number, regPntY: number, bgColor: number, transparency: boolean = false) {
        super((width <= 0 ? 1 : width), (height <= 0 ? 1 : height), transparency, bgColor);

        if (bgColor == 0) {
            bgColor = 0xFFFFFF;
            transparency = true;
        }

        this._registrationPointX = regPntX;
        this._registrationPointY = regPntY;

    }
}
